

const CartContentArea = ({ children }) => {
  return (
    <div className="w-full md:w-[500px] lg:w-[600px] xl:w-addressWidth bg-white mt-3 p-3">{children}</div>
  );
};

export default CartContentArea;
